// import AppJoin from '@/components/widgets/join'
import AppTeam from './Team'
import AppLost from './Lost'
import AppFooter from '@/components/widgets/Footer'

export default {
  name: 'AppOverlay',
  components: { AppTeam, AppLost, AppFooter },
  props: {
    state: { type: Object, required: true },
    screen: { type: String, required: true }
  },
  data () {
    return {
      VERSION: VERSION // eslint-disable-line
    }
  },
  methods: {
    start (evt) {
      this.$emit('start', evt)
    },
    teamSelection (evt) {
      this.$emit('teamSelection', evt)
    },
    mainMenu (evt) {
      this.$emit('mainMenu', evt)
    }
  }
}
